import reportWebVitals from './reportWebVitals';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { routes } from './routes';

import Layout from './components/pages/Layout';
import Loader from './components/ui/Loader';
import './global.css';

const router = createBrowserRouter(
	routes.map(route => ({
		path: route.path,
		element: (
			<Suspense fallback={<Loader />}>
				<Layout pageInfo={route.page} bgClass={route.bgClass}>
					<route.component />
				</Layout>
			</Suspense>
		),
	}))
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<RouterProvider router={router} />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
